export class AccessDeniedError extends Error {}
